import React from "react";
import { useStyles } from '../styles/CodeJamCreateTextJamProject.styles';
import { useStyles as useGeneralStyles } from '../styles/CodeJamModal.styles';
import { AppRoutes } from '@/constants';
import { IDE_TEMPLATES } from "@/utils/constants"

import Typography from "@material-ui/core/Typography";

import ArrowRight from "@/images/arrow-right.svg";

import PythonLogo from "@/images/ide/python.svg";
import Html5Logo from "@/images/ide/html5.svg";
import P5JsLogo from "@/images/ide/P5js.svg";

import ProjectTypeCard from './ProjectTypeCard';

const CodeJamCreateTextJamProject = ({ onClick }) => {
  const classes = useStyles();
  const generalClasses = useGeneralStyles();

  return <>
    <Typography className={generalClasses.tabElementHeader}>Start with a blank project</Typography>
    <div className={classes.content}>
      <div className={classes.text}>
        <div className={classes.textContainer}>
          Choose your programming language
          <img
            alt="Arrow right"
            className={classes.arrowRightIcon}
            src={ArrowRight}
          />
        </div>
      </div>
      <div className={classes.secondary}>
        <ProjectTypeCard
          projectTypeLogo={PythonLogo}
          projectTypeTitle="Python"
          onClick={() => {onClick(`${AppRoutes.TEXT_JAM}/${IDE_TEMPLATES.python}`)}}>
            A flexible, all-purpose language to build tons of different projects—like games, apps, and tools that work with data or solve problems.
        </ProjectTypeCard>
        <ProjectTypeCard
          projectTypeLogo={Html5Logo}
          projectTypeTitle="HTML, CSS, JS"
          onClick={() => {onClick(`${AppRoutes.TEXT_JAM}/${IDE_TEMPLATES.web}`)}}>
            Build a website with HTML to create the structure, CSS to style it, and JavaScript to make it interactive.
        </ProjectTypeCard>
        <ProjectTypeCard
          projectTypeLogo={P5JsLogo}
          projectTypeTitle="P5.JS"
          onClick={() => {onClick(`${AppRoutes.TEXT_JAM}/${IDE_TEMPLATES.p5js}`)}}>
            Create interactive web art with this creative coding JavaScript library.
        </ProjectTypeCard>
      </div>
    </div>
  </>
}

export default CodeJamCreateTextJamProject;
